export interface ObservableArrayChangedItem<T> {
  item: T;
  index: number;
}
